<template>
  <div class="gateway-row">
    <div class="gateway-top">
      <div class="left">
        <img src="@/assets/images/gateway/logo.jpg"/>
        <p>专注商业服务   追求卓越品质</p>
      </div>
      <div class="right">
        <el-menu mode="horizontal" :default-active="activeIndex" @select="routerChange">
          <el-menu-item index="home">首页</el-menu-item>
          <el-menu-item index="bigScreen">园区沙盘</el-menu-item>
          <el-menu-item index="entrust">委托找房</el-menu-item>
          <el-menu-item index="join">加盟我们</el-menu-item>
        </el-menu>
        <div class="button" @click="routerChange('login')">员工入口</div>
      </div>
    </div>
    <slot></slot>
    <div class="gateway-foot">
      <div class="left">
        <div>
          <img src="@/assets/images/gateway/icon-ph.png"/>
          <span>021-62380024（办公室），021-52198305（招商）</span>
        </div>
        <div>
          <img src="@/assets/images/gateway/icon-ad.png"/>
          <span>上海市长宁区协和路1158号</span>
        </div>
        <div>
          <span>备案号：</span>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" style="color: white; text-decoration: none;">沪ICP备2023006609号</a>
        </div>
      </div>
      <div class="right">
        <img src="@/assets/images/gateway/logo.jpg"/>
        <div>上海鑫达实业（集团）有限公司</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeIndex: 'home'
    }
  },
  mounted () {
    let arr = this.$route?.path?.split('/')
    this.activeIndex = arr[arr.length - 1] || 'home'
    // 解决联系我们滚动位置不变
    window.scrollTo(0, 0)
  },
  methods: {
    routerChange (val) {
      let routerJson = {
        home: '/home',
        bigScreen: '/bigScreen',
        join: '/join',
        login: '/login',
        entrust: '/entrust'
      }
      this.$router.push(routerJson[val])
    }
  }
}
</script>

<style lang="scss" scoped>
.gateway-row {
  background: #fff;
  position: relative;
  padding-top: 0.8rem;
  padding-bottom: 1.3rem;
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  .gateway-top {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 0.8rem;
    background: #fff;
    color: #2D4978;
    font-size: 0.15rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10%;
    box-sizing: border-box;
    box-shadow: rgba(0,0,0,0.2) 0 1px 2px;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 0.6rem;
        margin-right: 0.1rem;
      }
    }
    .right {
      display: flex;
      /deep/ .el-menu--horizontal {
        border-bottom: none;
        .el-menu-item {
          color: #333333;
          height: 0.4rem;
          line-height: 0.4rem;
          border-bottom: none;
          padding: 0 0.2rem;
          font-size: 0.15rem;
        }
        .is-active {
          position: relative;
          color: #2D4978;
          &::after {
            position: absolute;
            content: '';
            height: 0.05rem;
            left: 0.2rem;
            right: 0.2rem;
            bottom: 0;
            background: #2D4978;;
          }
        }
      }
      .button {
        margin-left: 0.3rem;
        border: 0.02rem solid #355791;
        padding: 0.05rem 0.2rem;
        box-sizing: border-box;
        border-radius: 0.1rem;
        cursor: pointer;
        &:hover {
          background: #355791;
          color: #fff;
        }
      }
    }
  }
  .gateway-foot {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1.3rem;
    background: #192631;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10%;
    box-sizing: border-box;
    .left {
      font-size: 0.17rem;
      line-height: 0.3rem;
      img {
        width: 0.15rem;
        margin-right: 0.1rem;
      }
    }
    .right {
      display: flex;
      align-items: center;
      font-size: 0.3rem;
      font-weight: 600;
      img {
        width: 0.8rem;
        margin-right: 0.15rem;
      }
    }
  }
}

</style>